import Swiper from 'swiper/js/swiper.min';
export default {
  init: function init() {
    var swiper = new Swiper('#thumb-swiper', {
      spaceBetween: 16,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.thumb-swiper-container .swiper-button-next',
        prevEl: '.thumb-swiper-container .swiper-button-prev'
      }
    });
    var swiper2 = new Swiper('#gallery-swiper', {
      speed: 1000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: swiper
      }
    });
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/flex.js